import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {
  RequestDownloadExcelDto,
  RequestDownloadPdfDto,
  RequestReportSendEmailExcelDto, RequestReportSendEmailPdfDto,
  ResponseReportSendEmailExcelDto, ResponseReportSendEmailPdfDto
} from "../dto/overtime-report.dto";
import {Observable} from "rxjs";

@Injectable()
export class OvertimeReportApi {
  private service: string = '';
  private model: string = 'OvertimeReport';
  private timeout: number = (5 * 60) * 1000;

  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  downloadExcel(data: RequestDownloadExcelDto){
    const method: string = 'POST';
    const func: string = 'downloadExcel';
    const params: RequestDownloadExcelDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  downloadPdf(data: RequestDownloadPdfDto){
    const method: string = 'POST';
    const func: string = 'downloadPdf';
    const params: RequestDownloadPdfDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  reportSendEmailExcel(data: RequestReportSendEmailExcelDto): Observable<ResponseReportSendEmailExcelDto>{
    const method: string = 'POST';
    const func: string = 'reportSendEmailExcel';
    const params: RequestReportSendEmailExcelDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseReportSendEmailExcelDto>(method, url, params, urlParams, body, null, this.timeout);
  }

  reportSendEmailPdf(data: RequestReportSendEmailPdfDto):Observable<ResponseReportSendEmailPdfDto>{
    const method: string = 'POST';
    const func: string = 'reportSendEmailPdf';
    const params: RequestReportSendEmailPdfDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseReportSendEmailPdfDto>(method, url, params, urlParams, body, null, this.timeout);
  }



}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/overtime-report.api.ts